import React from 'react';
import Navbar from '../components/navbar';
import profilepic from "../assets/profilepic2.png";
import Project from '../components/Project';
import Skills from '../components/Skills';
import Experience from '../components/Experience';
import Footer from '../components/Footer';
import mongoLogo from '../assets/mongodblogopng.png';
import expressLogo from '../assets/expressjslogo.png';
import reactLogo from '../assets/reactlogo.png';
import nodeLogo from '../assets/nodejslogo.png';

function Home() {
  const techStack = [
    { name: 'M', img: mongoLogo },
    { name: 'E', img: expressLogo },
    { name: 'R', img: reactLogo },
    { name: 'N', img: nodeLogo }
  ];

  return (
    <div className="home-container">
      <Navbar />

      <section className="home" id="home">
        <div className="home-content">
          <div className="home-text">
            <h1 className='name'>
              Gabriel <span>Samson</span>
            </h1>

            <div className='role'>
              <h2 className='left'>WEB</h2>
              <h2 className='right'>DEVELOPER</h2>
            </div>
            <div className="home-horizontal">
              {techStack.map((tech) => (
                <div key={tech.name} className="home-item">
                  <img src={tech.img} alt={tech.name} />
                  <p>{tech.name}</p>
                </div>
              ))}
            </div>
            <p className='subtitle'>
              Information Technology <br />Graduate
            </p>
          </div>

          <div className="home-image">
            <img className="profilepic" src={profilepic} alt="Profile" />
          </div>

        </div> {/* <-- Close home-content */}


      </section>
      <Project />
      <Skills />
      <Experience />
      <Footer />
    </div>
  );
}

export default Home;
